export const stringMapDefault = {
    toggleMenu: "Toggle Menu",
    selected: "Selected",
    back: "Back",
    viewNested: "View nested options",
    selectAllLabel: "Select All",
    cancel: "Cancel",
    apply: "Apply",
    added: "{label} Added",
    removed: "{label} Removed",
    remove: "Remove {label}",
    close: "Close"
};
